import { IsiPresentationLogic } from "./IsiPresentationLogic";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiDtoPlColRaccRequest, IsiDtoPlColRaccResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlColRacc";


export class IsiPlColRacc extends IsiPresentationLogic {

    constructor() {
        super("IsiPlColRaccHandler");
    }

    /** Récupère une liste de données à afficher dans un editeur de type connexe */
    public async GetColRacc(gridViewId : string,col: string): Promise<String> {
        let params = IsiDtoPlColRaccRequest.fromJS({
            columnName: col,
            gridViewId: gridViewId,
            response: IsiDtoPlColRaccResponse.fromJS({
                })
            });

        const result: IIsiUIFlowResultGeneric<IsiDtoPlColRaccRequest> = await this.ajaxWithErrorHandling("GetColRacc", params, true);

         return result?.reponse?.response?.raccourci;      
    }

}